import { render, staticRenderFns } from "./V2EventList.vue?vue&type=template&id=3e862772&scoped=true&"
import script from "./V2EventList.vue?vue&type=script&lang=js&"
export * from "./V2EventList.vue?vue&type=script&lang=js&"
import style0 from "./V2EventList.vue?vue&type=style&index=0&id=3e862772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e862772",
  null
  
)

export default component.exports